/**
 * ReaderFooter - 閱讀器底部導航
 */

import { Link } from 'react-router-dom';
import type { ChapterNav } from '../../services/types';
import type { ThemeStyles } from './types';

export interface ReaderFooterProps {
  novelId: string | undefined;
  nav: ChapterNav | null;
  showUI: boolean;
  theme: 'light' | 'sepia' | 'dark';
  themeStyles: ThemeStyles;
  scrollProgress: number;
  onPrevChapter: () => void;
  onNextChapter: () => void;
}

export function ReaderFooter({
  novelId,
  nav,
  showUI,
  theme,
  themeStyles,
  scrollProgress,
  onPrevChapter,
  onNextChapter,
}: ReaderFooterProps) {
  return (
    <footer
      className={`fixed bottom-0 left-0 right-0 z-50 transition-all duration-300 ${
        showUI ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
      style={{
        backgroundColor: theme === 'dark' ? 'rgba(26,26,26,0.95)' : 'rgba(255,255,255,0.95)',
        backdropFilter: 'blur(10px)',
      }}
    >
      <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onPrevChapter();
          }}
          disabled={!nav?.prev}
          className="px-4 py-2 rounded-lg disabled:opacity-30 disabled:cursor-not-allowed transition-colors"
          style={{
            backgroundColor: theme === 'dark' ? '#333' : '#f3f4f6',
            color: themeStyles.color,
          }}
        >
          上一章
        </button>

        <div className="text-center">
          <Link
            to={novelId ? `/novels/${novelId}` : '/novels'}
            className="text-sm hover:underline"
            style={{ color: themeStyles.color, opacity: 0.7 }}
            onClick={(e) => e.stopPropagation()}
          >
            目錄
          </Link>
          <p className="text-xs mt-0.5" style={{ color: themeStyles.color, opacity: 0.4 }}>
            {Math.round(scrollProgress * 100)}%
          </p>
        </div>

        <button
          onClick={(e) => {
            e.stopPropagation();
            onNextChapter();
          }}
          disabled={!nav?.next}
          className="px-4 py-2 bg-primary-600 text-white rounded-lg disabled:opacity-30 disabled:cursor-not-allowed hover:bg-primary-700 active:bg-primary-800 transition-colors"
        >
          下一章
        </button>
      </div>
    </footer>
  );
}
